import React from 'react';
import { SimulationResultsMenu } from '../components/map/components/SimulationResultsMenu';

/**
 * Full-page view for Simulation Results (deep-linkable at /simulation-results).
 * Reuses the same content as the sidebar Simulation Results drawer.
 */
function SimulationResultsPage() {
  return (
    <div data-testid="sim-results.page.root" data-route-ready="true">
      <SimulationResultsMenu
        open={true}
        onClose={() => {}}
        variant="page"
      />
    </div>
  );
}

export default SimulationResultsPage;
